export const batchProcess = async <T>({
  jobs,
  batchSize,
  pauseBetweenBatchesMs,
}: {
  jobs: (() => Promise<T>)[];
  batchSize: number;
  pauseBetweenBatchesMs?: number;
}): Promise<T[]> => {
  const results: T[] = [];

  for (let i = 0; i < jobs.length; i += batchSize) {
    if (pauseBetweenBatchesMs && i !== 0) {
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => {
        setTimeout(resolve, pauseBetweenBatchesMs);
      });
    }

    const batch = jobs.slice(i, i + batchSize);
    // eslint-disable-next-line no-await-in-loop
    const batchResults = await Promise.all(batch.map((job) => job()));
    results.push(...batchResults);
  }

  return results;
};
